import { OutDebt } from '../generated/graphql';

const getVirtualDebtChildrenBalance = (debts: OutDebt[], getBalance?: (od: OutDebt) => number) => {
  return debts
    .map((child) => getBalance?.(child) || child.balance || 0)
    .reduce((prev, curr) => prev + curr, 0);
};

export default getVirtualDebtChildrenBalance;
